import React from 'react'
import { Form, ErrorMessage, Field, useFormikContext} from 'formik'

const LoginForm = ({loading}) => {
  const {touched, dirty, isValid, errors} = useFormikContext()

  return (
    <div className='w-full'>
        <Form className='space-y-4'>
            {/* Email Field */}
            <div className='group'>
                <label htmlFor="email" className='block text-sm font-semibold text-gray-200 mb-2'>
                    Email Address
                </label>
                <div className='relative'>
                  <Field
                      name="email"
                      id="email"
                      type='email'
                      placeholder="you@example.com"
                      className={`
                        w-full px-4 py-3 rounded-lg
                        background: rgba(255, 255, 255, 0.1);
                        border transition-all duration-300
                        focus:outline-none focus:ring-2
                        backdrop-blur-sm
                        ${ touched.email && errors.email ?
                          "bg-red-500 bg-opacity-10 border-red-400 text-red-200 focus:ring-red-400" :
                          "bg-white bg-opacity-5 border-gray-400 border-opacity-20 text-white placeholder-gray-400 hover:bg-opacity-10 focus:bg-opacity-15 focus:ring-blue-400"
                        }
                      `}
                      autoComplete="off"
                  />
                  {touched.email && errors.email && (
                    <div className='absolute right-3 top-3'>
                      <svg className="w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18.101 12.93a1 1 0 00-1.414-1.414L10 15.586l-3.293-3.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8z" clipRule="evenodd" />
                      </svg>
                    </div>
                  )}
                </div>
                {touched.email && errors.email && (
                  <div className='mt-2 flex items-center gap-2 text-red-300 text-xs font-medium'>
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    <ErrorMessage name='email' />
                  </div>
                )}
            </div>

            {/* Password Field */}
            <div className='group'>
                <label htmlFor="passwd" className='block text-sm font-semibold text-gray-200 mb-2'>
                    Password
                </label>
                <div className='relative'>
                  <Field
                      name="passwd"
                      id="passwd"
                      type='password'
                      placeholder="Enter your password"
                      className={`
                        w-full px-4 py-3 rounded-lg
                        background: rgba(255, 255, 255, 0.1);
                        border transition-all duration-300
                        focus:outline-none focus:ring-2
                        backdrop-blur-sm
                        ${ touched.passwd && errors.passwd ?
                          "bg-red-500 bg-opacity-10 border-red-400 text-red-200 focus:ring-red-400" :
                          "bg-white bg-opacity-5 border-gray-400 border-opacity-20 text-white placeholder-gray-400 hover:bg-opacity-10 focus:bg-opacity-15 focus:ring-blue-400"
                        }
                      `}
                      autoComplete="off"
                  />
                  {touched.passwd && errors.passwd && (
                    <div className='absolute right-3 top-3'>
                      <svg className="w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18.101 12.93a1 1 0 00-1.414-1.414L10 15.586l-3.293-3.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8z" clipRule="evenodd" />
                      </svg>
                    </div>
                  )}
                </div>
                {touched.passwd && errors.passwd && (
                  <div className='mt-2 flex items-center gap-2 text-red-300 text-xs font-medium'>
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    <ErrorMessage name='passwd' />
                  </div>
                )}
            </div>

            {/* Submit Button */}
            <div className='pt-4'>
                <button 
                    type='submit'
                    disabled={!(dirty && isValid) || loading}
                    className={`
                      w-full py-3 px-4 rounded-lg font-semibold
                      transition-all duration-300 transform
                      focus:outline-none focus:ring-2 focus:ring-offset-2
                      ${ !(dirty && isValid) || loading ? 
                        "bg-gray-500 bg-opacity-40 text-gray-400 cursor-not-allowed" 
                        : 'bg-gradient-to-r from-blue-500 to-purple-600 text-white hover:shadow-lg hover:shadow-purple-500/50 active:scale-95 focus:ring-purple-400'
                      }
                    `}
                >
                    {loading ? (
                      <span className='flex items-center justify-center gap-2'>
                        <svg className="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Signing In...
                      </span>
                    ) : 'Sign In'}
                </button>
            </div>
        </Form>
    </div>
  )
}

export default LoginForm